import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import GridIcon from '@mui/icons-material/GridGoldenratio';

import { ReadFile, useHiddenFileSelect } from '@paragon/client-tools';

import { useAppMonitor } from '../../../../monitor';
import { uploadLayoutDxf } from '../../../../store/actions/layout/layoutActions';
import { deleteAllWorkLines } from '../../../../store/actions/layout/workLineActions';
import { clearRightClickedItems } from '../../../../store/slices/viewportSlice';
import { useAppDispatch } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuFragment } from '../common/SceneMenuFragment';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function WorkLinesContainerMenu() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const [renderFileSelect, selectFile] = useHiddenFileSelect('.dxf', false);

  const processUploadedFile = async (file: ReadFile) => await dispatch(uploadLayoutDxf(file));

  return (
    <SceneMenuFragment>
      <SceneMenuContent>
        <AddItemMenuItem type="workLine" userVisibleTerm="Work Line" />

        <SceneMenuItem
          icon={<GridIcon />}
          text="Import Lines from DXF"
          onClick={(event) => {
            // prevent menu from closing immediately, which would unmount file select and cancel the upload
            event.preventDefault();

            selectFile()
              .then(processUploadedFile)
              .finally(() => {
                dispatch(clearRightClickedItems());
              });

            monitor.recordInteraction('Import Layout DXF button clicked');
          }}
        />

        <SceneMenuItem
          text="Delete All Work Lines"
          icon={<DeleteIcon />}
          onClick={() => {
            dispatch(deleteAllWorkLines());
            monitor.recordInteraction('Delete All Work Lines menu item clicked');
          }}
        />
      </SceneMenuContent>

      {renderFileSelect()}
    </SceneMenuFragment>
  );
}
